import React from "react";
import { Mail, MessageCircle, Phone } from "lucide-react";

const ElevenLabsChannelIcon = () => {
  const [imgError, setImgError] = React.useState(false);
  if (imgError) {
    return (
      <div className="w-[23px] h-[23px] bg-indigo-500 rounded flex items-center justify-center text-white text-xs font-bold">
        11
      </div>
    );
  }
  return (
    <img
      src="/icons/elevenlabs.svg"
      alt="Eleven Labs"
      className="w-[23px] h-[23px]"
      onError={() => setImgError(true)}
    />
  );
};

export const CHANNEL_TYPES = [
  {
    name: "Forward Number",
    description: "Forward calls to a phone number",
    icon: <Phone className="w-[23px] text-[#6366F1]" />,
    type: "forward_number",
  },
  {
    name: "Email",
    description: "Send notifications via email",
    icon: <Mail className="lg:w-[23px] object-cover text-[#3B82F6]" />,
    type: "email",
  },
  {
    name: "SMS",
    description: "Send notifications via SMS",
    icon: <MessageCircle className="w-[23px] text-green-500" />,
    type: "sms",
  },
  {
    name: "Front",
    description: "Integrate with Front inbox",
    icon: (
      <img
        src="/icons/front.png"
        className="text-[#4F46E5] w-[23px] h-[23px]"
        alt="Front"
      />
    ),
    type: "front",
  },
  {
    name: "Slack",
    description: "Send notifications to Slack",
    icon: (
      <img
        src="/icons/slack.png"
        className="text-[#4F46E5] w-[23px] h-[23px]"
        alt="Slack"
      />
    ),
    type: "slack",
  },
  {
    name: "Eleven Labs AI Agent",
    description: "Receive or Place Calls with the ElevenLabs AI Voice Agent",
    icon: <ElevenLabsChannelIcon />,
    type: "elevenlabs",
    beta: true,
  },
];

export function getChannelType(type) {
  return CHANNEL_TYPES.find((item) => item.type === type) || CHANNEL_TYPES[0];
}
